import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

function Footer() {


  const [error, setError] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
  })
  const handleSubmit = (event) => {
    event.preventDefault();
  
    let { name, email } = formData;
  
    setError(false);
    setEmailError(false);
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!name || !email) {
      setError(true);
      return;
    }
  
    if (!emailRegex.test(email)) {
      setEmailError(true);
      return;
    }
  
    const serviceID = "service_v7gan2l";
    const templateID = "template_wnk2hma";
    const publicKey = "lO1PFAVrfhoLWzn19";
  
    const templateParams = {
      name: formData.name,
      email: formData.email,
    };
  
    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log("Subscribed successfully!", response);
        Swal.fire({
          icon: 'success',
          title: 'Message Sent',
          text: 'Your subscription message was sent successfully!',
        });
        setFormData({
          name: "",
          email: "",
        });
      })
      .catch((error) => {
        console.error("Email sending failed!", error);
        Swal.fire({
          icon: 'error',
          title: 'Send Failed',
          text: 'Something went wrong. Please try again later.',
        });
      });
  };
  







  return (
    <div>
      <div>
        <footer className="footer widget-footer ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
          <div className="first-footer">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 widget-area">
                  <div className="widget widget_text clearfix">
                    <div className="d-sm-flex align-items-center">
                      <div className="footer-logo">
                        <svg style={{ width: '200px', height: '100px' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 308.96 256.74" xmlSpace="preserve">
                          <style type="text/css" dangerouslySetInnerHTML={{ __html: "\n                                                .st0 {\n                                                    fill: #FFFFFF;\n                                                }\n\n                                                .st1 {\n                                                    fill-rule: evenodd;\n                                                    clip-rule: evenodd;\n                                                    fill: #FFFFFF;\n                                                }\n\n                                                .st2 {\n                                                    fill-rule: evenodd;\n                                                    clip-rule: evenodd;\n                                                    fill: #2197D5;\n                                                }\n\n                                                .st3 {\n                                                    fill-rule: evenodd;\n                                                    clip-rule: evenodd;\n                                                }\n\n                                                .st4 {\n                                                    fill: #13110C;\n                                                }\n                                            " }} />
                          <rect x="19.19" y="164.74" className="st0" width="1.56" height="21.03" />
                          <polygon className="st0" points="42.21,185.78 27.39,167.08 27.39,185.78 25.89,185.78 25.89,164.74 27.36,164.74 41.87,183.04   41.87,164.74 43.38,164.74 43.38,185.78 " />
                          <polygon className="st0" points="58.47,166.18 58.47,185.78 56.9,185.78 56.9,166.18 49.57,166.18 49.57,164.74 65.8,164.74   65.8,166.18 " />
                          <polygon className="st0" points="72.1,185.78 72.1,164.74 87.07,164.74 87.07,166.18 73.67,166.18 73.67,174.45 85.71,174.45   85.71,175.89 73.67,175.89 73.67,184.33 87.22,184.33 87.22,185.78 " />
                          <path className="st0" d="M108.6,185.78l-6.7-8.72h-6.88v8.72h-1.56v-21.04h8.84c4.54,0,7.51,2.46,7.51,5.98v0.06  c0,3.52-2.62,5.53-6.16,6.01l6.94,8.99H108.6z M108.24,170.78c0-2.82-2.22-4.6-6.04-4.6h-7.18v9.47h7.09c3.52,0,6.13-1.77,6.13-4.81  V170.78z" />
                          <polygon className="st0" points="133.73,185.78 118.91,167.08 118.91,185.78 117.41,185.78 117.41,164.74 118.88,164.74 133.4,183.04   133.4,164.74 134.9,164.74 134.9,185.78 " />
                          <path className="st0" d="M160.73,185.78l-2.67-5.89h-12.41l-2.67,5.89h-1.62l9.8-21.18h1.5l9.8,21.18H160.73z M151.87,166.3l-5.56,12.17  h11.09L151.87,166.3z" />
                          <polygon className="st0" points="175.51,166.18 175.51,185.78 173.95,185.78 173.95,166.18 166.61,166.18 166.61,164.74 182.84,164.74   182.84,166.18 " />
                          <rect x="189.69" y="164.74" className="st0" width="1.56" height="21.04" />
                          <path className="st0" d="M208,186.14c-6.37,0-10.55-5.08-10.55-10.82v-0.06c0-5.74,4.24-10.88,10.61-10.88  c6.37,0,10.55,5.08,10.55,10.82c0.03,0.03,0.03,0.03,0,0.06C218.61,181,214.37,186.14,208,186.14 M216.99,175.26  c0-5.2-3.79-9.47-8.99-9.47c-5.2,0-8.93,4.21-8.93,9.41v0.06c0,5.2,3.79,9.47,8.99,9.47c5.2,0,8.93-4.21,8.93-9.41V175.26z" />
                          <polygon className="st0" points="241.35,185.78 226.54,167.08 226.54,185.78 225.04,185.78 225.04,164.74 226.51,164.74 241.02,183.04   241.02,164.74 242.53,164.74 242.53,185.78 " />
                          <path className="st0" d="M268.14,185.78l-2.67-5.89h-12.41l-2.68,5.89h-1.62l9.8-21.18h1.5l9.8,21.18H268.14z M259.27,166.3l-5.56,12.17  h11.09L259.27,166.3z" />
                          <polygon className="st0" points="275.85,185.78 275.85,164.74 277.42,164.74 277.42,184.33 289.77,184.33 289.77,185.78 " />
                          <polygon className="st1" points="19.2,80.9 31.24,80.9 70.85,132.02 70.85,80.9 83.63,80.9 83.63,154.84 72.75,154.84 31.98,102.23   31.98,154.84 19.2,154.84 " />
                          <polygon className="st1" points="162.86,154.84 148.49,154.84 126.2,98.01 104.02,154.84 89.97,154.84 120.71,80.37 132.12,80.37 " />
                          <path className="st1" d="M164.74,143.32l7.61-9.05c6.89,5.97,13.78,9.36,22.73,9.36c7.82,0,12.76-3.6,12.76-9.05v-0.21  c0-5.14-2.88-7.92-16.25-11c-15.32-3.7-23.96-8.23-23.96-21.5v-0.21c0-12.34,10.28-20.88,24.58-20.88c10.49,0,18.82,3.19,26.13,9.05  l-6.79,9.57c-6.48-4.84-12.96-7.41-19.54-7.41c-7.41,0-11.73,3.8-11.73,8.54v0.21c0,5.56,3.29,8.02,17.07,11.31  c15.22,3.71,23.14,9.16,23.14,21.09v0.2c0,13.48-10.59,21.5-25.72,21.5C183.77,154.84,173.38,151.04,164.74,143.32" />
                          <polygon className="st2" points="289.3,80.88 277.13,80.88 255.04,118.13 276.78,154.84 289.3,154.84 268.21,118.13 " />
                          <polygon className="st2" points="270.52,80.88 251.16,80.88 228.32,118.13 251.66,154.84 270.52,154.84 249.42,118.13 " />
                          <polygon className="st2" points="228.32,106.05 228.32,80.88 244.73,80.88 228.32,106.74 " />
                          <polygon className="st2" points="228.32,129.66 228.32,154.84 244.73,154.84 228.32,128.97 " />
                          <path className="st0" d="M284.1,62.61c1.11,0,2.18,0.28,3.24,0.85c1.05,0.57,1.87,1.38,2.46,2.43c0.59,1.05,0.88,2.16,0.88,3.3  c0,1.13-0.29,2.23-0.87,3.27c-0.58,1.05-1.39,1.86-2.44,2.44c-1.05,0.58-2.14,0.87-3.28,0.87c-1.14,0-2.23-0.29-3.28-0.87  c-1.04-0.58-1.86-1.39-2.44-2.44c-0.58-1.05-0.87-2.14-0.87-3.27c0-1.15,0.29-2.25,0.89-3.3c0.59-1.06,1.41-1.87,2.46-2.43  C281.91,62.89,282.99,62.61,284.1,62.61 M284.1,63.7c-0.92,0-1.83,0.24-2.7,0.71c-0.87,0.48-1.56,1.15-2.06,2.03  c-0.49,0.88-0.74,1.8-0.74,2.75c0,0.95,0.24,1.86,0.73,2.73c0.49,0.87,1.16,1.55,2.04,2.04c0.87,0.48,1.78,0.73,2.73,0.73  c0.95,0,1.86-0.24,2.73-0.73c0.87-0.49,1.55-1.16,2.03-2.04c0.48-0.87,0.73-1.78,0.73-2.73c0-0.95-0.25-1.87-0.74-2.75  c-0.49-0.88-1.18-1.56-2.06-2.03C285.91,63.94,285.01,63.7,284.1,63.7 M281.21,72.84v-7.09h2.43c0.83,0,1.43,0.07,1.81,0.2  c0.37,0.13,0.67,0.36,0.89,0.68c0.22,0.32,0.33,0.67,0.33,1.04c0,0.52-0.19,0.97-0.55,1.35c-0.37,0.39-0.86,0.6-1.47,0.65  c0.25,0.1,0.45,0.23,0.6,0.38c0.28,0.28,0.63,0.75,1.05,1.4l0.86,1.39h-1.4l-0.63-1.12c-0.49-0.88-0.89-1.43-1.2-1.65  c-0.21-0.16-0.51-0.24-0.92-0.24h-0.67v3.01H281.21z M282.35,68.85h1.39c0.66,0,1.12-0.1,1.36-0.3c0.24-0.2,0.36-0.46,0.36-0.79  c0-0.21-0.06-0.39-0.18-0.56c-0.12-0.17-0.28-0.29-0.48-0.37c-0.2-0.08-0.59-0.12-1.15-0.12h-1.3V68.85z" />
                        </svg>
                      </div>
                      <div className="textwidget widget-text">
                        <p className="p-0 m-0">NASK International is a sourcing and buying agency engaged in the provision & procurement of Textiles & Garments.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="second-footer">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 widget-area">
                  <div className="widget widget_text margin_right10 clearfix">
                    <h3 className="widget-title">Get Free Estimate</h3>
                    <div className="textwidget widget-text">
                      <div className="call_detail">
                        <h3 className="fs-24">+92 305 1115508</h3>
                        <div className="padding_top10 padding_bottom10">
                          <p>Our team is available for quick scheduling and safe transactions.</p>
                        </div>
                        <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-white w-100 text-center" to="/contact-us">Request Online Form</Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 widget-area">
                  <div className="widget widget_nav_menu clearfix">
                    <h3 className="widget-title">Our Services</h3>
                    <ul id="menu-footer-quick-links" className="menu">
                      <li><Link to="/kitchen-textile">Textile</Link></li>
                      <li><Link to="/garments">Garments</Link></li>
                      <li><Link to="/cotton-tote-bags">Bags</Link></li>
                      <li><Link to="/inspection-services">Inspection Services</Link></li>
                      <li><Link to="/audit-services">Audit</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 widget-area">
                  <div className="widget widget-latest-tweets clearfix">
                    <h3 className="widget-title">Contact Us</h3>
                    <ul className="widget_contact_wrapper">
                      <li><i className="ttm-textcolor-skincolor fa fa-map-marker" />Office # 2, 3rd Floor 21, DHA Phase 8 - Ex Park View Block-CCA Lahore, 54000</li>
                      <li><i className="ttm-textcolor-skincolor fa fa-phone" />+92 305 1115508</li>
                      <li><i className="ttm-textcolor-skincolor fa fa-envelope-o" /><a href="mailto:sales@naskinternational.com">sales@naskinternational.com</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 widget-area">
                  <div className="widget newsletter_widget clearfix">
                    <form id="subscribe-form" className="newsletter-form" method="post" action="#" data-mailchimp="true">
                      <div className="mailchimp-inputbox clearfix" id="subscribe-content">
                        <div className="row m-0">
                          <div className="col-lg-9 d-sm-flex p-0" style={{gap:'10px'}}>
                         <div className="d-flex new_input_new_box" style={{flexDirection:'column', width:'48%'}}>
                          <input className='w-100' type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} name="NAME" id="txtname" placeholder="Your Name *"/>
                        {error && formData.name == '' ? <p className='text_input_validation'>Name is required</p> : ''}</div>
                    <div className="d-flex new_input_new_box" style={{flexDirection:'column' , width:'48%'}}>
                    <input className='w-100' type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} name="EMAIL" id="txtemail" placeholder="Your Email *"/>
                    {error && formData.email == '' ? <p className='text_input_validation'>Email is required</p> : ''}
                    </div>
                          </div>
                         <div className="col-lg-3 p-lg-0 d-flex justify-content-sm-end justify-content-center mt-lg-0 mt-4 ps-sm-0 pe-sm-4 px-0">
                         <button style={{position:'unset' , padding:'22px 20px', height:'60px' , width:'98%' , marginLeft:'1%'}} onClick={handleSubmit} className="new_box_new_button submit ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-icon-btn-right ttm-btn-style-fill ttm-btn-color-skincolor" type="submit">Subscribe Now<i className="fa fa-caret-right" aria-hidden="true" /></button>
                         </div>
                        </div>
                        
                      </div>
                      <div id="subscribe-msg" />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-footer-text copyright">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 widget-area">
                  <div className="widget widget_social clearfix d-flex justify-content-center">
                    <div className="social-icons text-lg-right">
                      <ul className="social-icons list-inline">
                        <li className="tm-social-facebook my-2"><a target="_blank" href="https://www.facebook.com/naskinternational/"><i className="fa fa-facebook" /></a></li>
                        <li className="tm-social-twitter my-2"><a target="_blank" href="https://twitter.com/NaskInternatio1"><i className="fa fa-twitter" /></a></li>
                        <li className="tm-social-flickr my-2"><a target="_blank" href="	https://www.instagram.com/naskinternational/"><i className="fa-brands fa-instagram" /></a></li>
                        <li className="tm-social-linkedin my-2"><a target="_blank" href="https://www.tiktok.com/@naskinternational"><i className="fa-brands fa-tiktok" /></a></li>
                        <li className="tm-social-linkedin my-2"><a target="_blank" href="	https://www.youtube.com/channel/UCcUtzsrX2K8mGfiNXW7Kq-g"><i className="fa-brands fa-youtube" /></a></li>
                        <li className="tm-social-linkedin my-2"><a target="_blank" href="https://www.pinterest.com/naskinternational/"><i className="fa-brands fa-pinterest-p" /></a></li>
                        <li className="tm-social-linkedin my-2"><a target="_blank" href="https://www.linkedin.com/company/nask-international/"><i className="fa fa-linkedin" /></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="text-center">
                    {/* <span className="cpy-text"> <Link to='/'><a className="ttm-textcolor-skincolor font-weight-500">Nask International </a></Link> All rights reserved.</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <a id="totop" onClick={() => window.scrollTo(0, 0)} >
          <i className="fa fa-angle-up" />
        </a>
      </div>

    </div>
  )
}

export default Footer